import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Col, Button, Input, Typography, Row, Image, Space, message, Form, Checkbox } from 'antd';

import CmbLingua from '../../Combos/CmbLingua';
import Configurazione from '../../Configurazione';
import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import './LogInclienti.css';

const { Title, Text } = Typography;

export default function LogInClienti() {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [username, setUsername] = useState<any>(localStorage.getItem('username')?.toString());
    const [password, setPassword] = useState<any>(localStorage.getItem('password')?.toString());

    useEffect(() => {
        form.setFieldValue('username', username);
        form.setFieldValue('password', password);
    }, [username, password, form]);

    const onFinish = () => {
        fetchx();
    };

    async function fetchx() {
        try {
            const data = {
                idSocieta: Configurazione().idsocieta,
                username: username,
                password: password,
            };
            const result = await api.post(Configurazione().apiBaseUrl + 'Tabelle/LoginCliente', data);

            if (result.data.token != null) {
                sessionManager.set(eVariableType.RagioneSociale, result.data.ragioneSociale);
                sessionManager.set(eVariableType.Tokencliente, result.data.token);
                sessionManager.set(eVariableType.IDSocieta, Configurazione().idsocieta);
                sessionManager.set(eVariableType.IDOperatore, result.data.idOperatore);

                if (form.getFieldValue('remember')) {
                    localStorage.setItem('username', username);
                    localStorage.setItem('password', password);
                } else {
                    localStorage.setItem('username', '');
                    localStorage.setItem('password', '');
                }
                navigate('/MagazzinoClienti');
            }
        } catch (error: any) {
            message.error(GetErrorMessage(error), 5);
        }
    }

    return (
        <div className="pnlx">
            <Row wrap>
                <Col flex={'auto'} xs={24} md={8} span={8}>
                    <Form form={form} name="clienti_login" initialValues={{ remember: true }} onFinish={onFinish}>
                        <div className="pnllg">
                            <div style={{ textAlign: 'center', paddingTop: '5%' }}>
                                <Image height={112} src="custom/logosocieta.png"></Image>
                                <Title level={2}>ID di accesso MarbleR2</Title>
                                <hr className="linea"></hr>
                                <div
                                    style={{
                                        padding: '10px',
                                        margin: '10px',
                                        backgroundColor: '#EFFBC5',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Text>
                                        Accedi al tuo account MarbleR2 utilizzando il tuo ID di accesso e la password.
                                        <br></br>Per ottenere un ID di accesso contatta
                                        <b> {Configurazione().companyname}</b>
                                    </Text>
                                </div>
                                <br></br>
                                <Space style={{ width: '80%' }} direction="vertical" size={5}>
                                    <Text className="titolo">Inserisci i tuoi dati di accesso</Text>
                                    <Form.Item
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message: stringres.t('inserireCampo') + ' ' + stringres.t('userName'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            prefix={<UserOutlined />}
                                            size="large"
                                            placeholder="Username / e-Mail"
                                        ></Input>
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: stringres.t('inserireCampo') + ' ' + stringres.t('psw'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            prefix={<LockOutlined />}
                                            size="large"
                                            placeholder="Password"
                                            type="Password"
                                        ></Input>
                                    </Form.Item>
                                    <Form.Item name="remember" valuePropName="checked">
                                        <Checkbox style={{ width: '60%' }}>Salva accesso</Checkbox>
                                    </Form.Item>
                                </Space>
                                <hr className="linea"></hr>
                                <Space size={5} style={{ width: '80%', marginTop: '15px' }} direction="vertical">
                                    <Button size="large" style={{ width: '60%' }} type="primary" htmlType="submit">
                                        Accedi
                                    </Button>
                                    <CmbLingua width="60%"></CmbLingua>
                                </Space>
                                <div className="allineadxbottom">
                                    <Image height={25} src="images/LogoIsodataBlu.png"></Image>
                                    <Text className="testostandard" style={{ fontSize: 10 }}></Text>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Col>
                <Col flex={'auto'} xs={0} md={16} span={16}>
                    <div>
                        <div style={{ marginLeft: '8%', marginTop: '7%' }}>
                            <Image height={140} src="IconaMR2_rid.png" style={{ paddingRight: '40px' }}></Image>
                            <Typography.Text className="testotitolo">Marble</Typography.Text>
                            <Typography.Text className="testotitolo" style={{ color: '#523CBB' }}>
                                R2
                            </Typography.Text>
                        </div>
                        <div style={{ marginLeft: '12%', marginTop: '10%' }}>
                            <Space direction="vertical" size={10}>
                                <Typography.Text className="testotitolo">
                                    Il tuo magazzino presso di noi
                                </Typography.Text>
                                <Text className="testoparagrafo">
                                    Inserisci i tuoi dati per accedere o contattaci per per ottenere i dati di accesso
                                </Text>
                                <Text className="testostandard">Potrai accedere alle sezioni:</Text>
                                <Text className="testostandard"> - Vostro magazzino</Text>
                                <Text className="testostandard"> - Visualizzazione DDT e Fatture </Text>
                                <Text className="testostandard"> - Lavorazioni eseguite sul vostro materiale</Text>
                            </Space>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
